<template>
    <div v-bind:class = "(editMode == 'NO') ? 'col-md-6 offset-md-3':'people-management-inner-content'" >
        <div class="form-group">
            <label class="label block-label">Salary to be transferred via <em class="required">*</em> </label>
            <label class="radio-holder ml-0 mb-0">
                Faysal Bank
                <input v-model="form.accountType" :selected="form.accountType == 'BANK'" type="radio" @click="form.paymentMethod = 'BANK'" value="BANK" id="btn-simsim" class="payment-transfer" name="paymentTransfer">
                <span class="checkmark"></span>
            </label>
        </div>
        <div class="payment-via simsim" v-show="form.paymentMethod == 'BANK'">
            <div class="form-group">
                <label class="label block-label"> Account Number  <em class="required">*</em> </label>
                <input placeholder="Account Number" v-model="form.accountNumber" type="text" name="accountNumber" class="number-field form-control" :class="{ 'is-invalid': form.errors.has('accountNumber') }" autocomplete="off">
                <has-error :form="form" field="accountNumber"></has-error>
            </div>
            <div class="form-group detail-fetched" v-if="form.account_detail == 'BANK'">
                <div class="fetched-inner">
                    <div class="fetched-image">
                        <img src="/images/table-dummy-image.jpg" alt="" />
                    </div>
                    <div class="fetched-detail">
                        <h3> {{form.account_information.customer_name}}  </h3>
                        <p> {{form.account_information.account_number}}  </p>
                    </div>
                </div>
                <div class="btn-holder mt-2 mb-2 text-right">
                    <a href="javascript:void(0)" v-if="editMode == 'NO'" class="btn btn-primary" @click="addEmployeePaymentDetail">Save</a>
                </div>
            </div>
            <a href="javascript:void(0)" @click="getEmployeeWalletDetail()" class="account fetch-info" title=""> Fetch Info </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            "form","banks","getEmployeeWalletDetail","addEmployeePaymentDetail","changeAccountDetail","editMode"
        ],
        data() {
            return {

            };
        },

        methods: {
        }
    };
</script>
